import { render, staticRenderFns } from "./PaginationView.vue?vue&type=template&id=d4e15d72&scoped=true&"
import script from "./PaginationView.vue?vue&type=script&lang=js&"
export * from "./PaginationView.vue?vue&type=script&lang=js&"
import style0 from "./PaginationView.vue?vue&type=style&index=0&id=d4e15d72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e15d72",
  null
  
)

export default component.exports